module.exports = __webpack_public_path__ + "img/8.df802e49.jpg";